import { render, staticRenderFns } from "./GroupDate.vue?vue&type=template&id=5df45d83&"
import script from "./GroupDate.vue?vue&type=script&lang=js&"
export * from "./GroupDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports